import { Button, Grid, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { AsnDetailReceiveLpnInfo, AsnToReceive } from '../Interfaces'
import { utcToLocal } from '../../../utils/dateHelper'
import { Modal } from '../../../components/_EOS/Modal'
import { useModal } from '../../../hooks/useModal'
import { ViewInfoLpn } from './ViewInfoLpn'

interface AsnDetailSelectionProps {
  Asn: AsnToReceive
}

export const AsnDetailSelection: React.FC<AsnDetailSelectionProps> = ({
  Asn
}) => {
  const lpnModalState = useModal('')
  const totalLpnsUnicas = Array.from(new Set(Asn.lpn.map((p) => p.lpn)))

  const ListaNombres = (
    lpns: AsnDetailReceiveLpnInfo[],
    maxMostrar: number = 5
  ) => {
    // Tomar solo los primeros 5 elementos (o el número especificado)
    // Obtener lpns únicas (distinct) usando Set
    const lpnsUnicas = Array.from(new Set(lpns.map((p) => p.lpn))).slice(
      0,
      maxMostrar
    )

    const nombresTexto = lpnsUnicas.join(', ')

    return (
      <div className='lista-lpns'>
        <p>{nombresTexto}</p>
      </div>
    )
  }

  return (
    <Fragment>
      <Grid container xs={12} spacing={1}>
        <Grid item xs={12}>
          <Typography variant='body2' component='p'>
            <b>Proveedor: </b>
            {Asn.supplierName}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2' component='p'>
            <b>Origen: </b>
            {Asn.supplierOriginName}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2' component='p'>
            <b>Unidades Totales: </b> {Asn.unitsQty}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2' component='p'>
            <b>Fecha: </b>{' '}
            {utcToLocal(Asn.asnCreatedDate, "dd-MM-yyyy' 'HH:mm:ss")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2' component='p'>
            <b>Lpn {Asn.lpn.length > 1 ? '(s)' : ''};</b>
            <span style={{ marginLeft: '4px' }}>{ListaNombres(Asn.lpn)}</span>
          </Typography>
        </Grid>
        {totalLpnsUnicas.length > 4 && (
          <Grid item xs={12}>
            <Button
              variant='text'
              color='primary'
              size='small'
              onClick={() => lpnModalState.openModal('xs')}
              style={{ textTransform: 'none' }}
            >
              {`Ver más (${totalLpnsUnicas.length})...`}
            </Button>
          </Grid>
        )}
      </Grid>
      <Modal
        open={lpnModalState.isOpen}
        onClose={lpnModalState.closeModal}
        title={lpnModalState.title}
        maxWidth={'xs'}
      >
        <ViewInfoLpn
          data={totalLpnsUnicas}
          handleClose={() => lpnModalState.closeModal()}
        />
      </Modal>
    </Fragment>
  )
}
